"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PurchaseOption = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _reactHookForm = require("react-hook-form");
var _hooks = require("../../../hooks");
var _context = require("../context");
var _types = require("../types");
var _Cashback = require("./Cashback");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const PurchaseOption = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    isBrandPartner,
    purchaseOptionCashback
  } = (0, _context.useSubscriptionModule)();
  const {
    control,
    formState: {
      disabled
    }
  } = (0, _reactHookForm.useFormContext)();
  const mode = (0, _reactHookForm.useWatch)({
    name: 'mode',
    control
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_constants.PURCHASE_OPTION),
    checked: !disabled && mode === _types.SubscriptionModuleMode.Purchase,
    children: [isBrandPartner ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Cashback.Cashback, {
      cashback: purchaseOptionCashback
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.FormControlLabel, {
      "data-testid": getTestId(_constants.PURCHASE_OPTION_RADIO),
      value: _types.SubscriptionModuleMode.Purchase,
      control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Radio, {
        disabled: disabled
      }),
      label: translations.purchaseOption
    })]
  });
};
exports.PurchaseOption = PurchaseOption;
//# sourceMappingURL=PurchaseOption.js.map